'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_Util$() {
}
export { $c_Lmealorama_Util$ as $c_Lmealorama_Util$ };
$p = $c_Lmealorama_Util$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_Util$;
/** @constructor */
function $h_Lmealorama_Util$() {
}
export { $h_Lmealorama_Util$ as $h_Lmealorama_Util$ };
$h_Lmealorama_Util$.prototype = $p;
$p.a3B = (function(num) {
  var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_RTLong$().ej((+Math.floor(num)));
  var whole_$_lo = $x_1.l;
  var whole_$_hi = $x_1.h;
  var frac = (num - ((4.294967296E9 * whole_$_hi) + (whole_$_lo >>> 0.0)));
  var strFrac = ((frac < 1.0E-4) ? new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some("") : (((frac > 0.124) && (frac < 0.126)) ? new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some("\u215b") : (((frac > 0.24) && (frac < 0.26)) ? new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some("\u00bc") : (((frac > 0.49) && (frac < 0.51)) ? new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some("\u00bd") : (((frac > 0.32) && (frac < 0.34)) ? new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some("\u2153") : (((frac > 0.65) && (frac < 0.67)) ? new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some("\u2154") : (((frac > 0.74) && (frac < 0.76)) ? new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some("\u00be") : $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$())))))));
  if (strFrac.b()) {
    var $x_2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sc_StringOps$().vy("%1.3f", $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().cr(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_O([num])));
  } else {
    var x0 = strFrac.i();
    var $x_2 = ((((whole_$_lo | whole_$_hi) === 0) ? "" : ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$s_RTLong__toString__I__I__T(whole_$_lo, whole_$_hi) + " ")) + x0);
  }
  return $x_2;
});
var $d_Lmealorama_Util$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_Util$, "mealorama.Util$", ({
  Hg: 1
}));
export { $d_Lmealorama_Util$ as $d_Lmealorama_Util$ };
var $n_Lmealorama_Util$;
function $m_Lmealorama_Util$() {
  if ((!$n_Lmealorama_Util$)) {
    $n_Lmealorama_Util$ = new $c_Lmealorama_Util$();
  }
  return $n_Lmealorama_Util$;
}
export { $m_Lmealorama_Util$ as $m_Lmealorama_Util$ };
//# sourceMappingURL=mealorama.-Util$.js.map
